import { Field } from "@src/lib/schemas";

export function getFieldsType(fields: Field[]) {
  let fieldsType: Record<string, string> = {};

  for (let field of fields) {
    const node = field.node;
    const resolvedSchema = node.resolvedSchema;
    const type = resolvedSchema.type;
    const camelizedKey = field.key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());

    if ("typescript_interface" in resolvedSchema && typeof resolvedSchema.typescript_interface === "string") {
      fieldsType[camelizedKey] = `${resolvedSchema.typescript_interface} | undefined`;
    } else if (type && typeof type === "string") {
      fieldsType[camelizedKey] = `${type} | undefined`;
    }
  }

  return JSON.stringify(fieldsType).replace(/"/g, "");
}
